// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__WDAE1","label":"Completed_label__2L8mI"};